export const LookUpConstants = {
  JSCommon: 'Common.YesNo',
  JSProfileVisatype: 'JSProfile.Visatype',
  JSProfileVisatype2: 'JSProfile.Visatype2',
  JSProfileVisatype2Spec: 'JSProfile.Visatype2Specs',
  JSProfileJobtype: 'JSProfile.Jobtype',
  JSProfessionalFrequency: 'JSProfessional.Frequency',
  JSProfessionalCurrency: 'GeneralCurrency',
  JSProfessionalHQualification: 'JSProfessional.HQualification',
  JSOtherContactsContactType: 'JSOtherContacts.ContactType',
  JSDocsDocType: 'JSDocs.DocType',
  SupplierDocsDocType: 'SupplierDocs.DocType',
  jobRequestJobType: 'jobRequestJobType',
  JobRequestRateType: 'JobRequestRateType',
  CommonActive: 'Common.Active',
  JSProfileStatus: 'JSProfile.Status',
  CommonSource: 'Common.Source',
  CommonJobStatus: 'Common.JobStatus',
};

export const StatusConstants = {
  InActive: false,
  Active: true,
};

export const JsConstants = {
  Verified: 'VERIFIED',
  'Non-Verified': 'NONVERIFIED',
};

export const SourceConstants = {
  Admin: 'Admin',
  Client: 'Client',
  Jobseeker: 'Jobseeker',
  Supplier: 'Supplier',
};

export const WALogic = {
  EAD: 'EAD',
  OTHERVISA: 'OTHERVISA'
};

export const OtherConstant = {
  LINKEDIN: 'LINKEDIN',
  BLOG: 'BLOG'
};

export const Message = {
  ResumeExtractError: 'No Data is extrated from the file. Please try again.',
  NoReferenceError:'Please add at least one reference'
};

export const inviteStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
}

export const Resumes = {
  ApiPath: '/JobSeeker/GetResPath/'
};

export const DocType = {
  Other: 'Other',
  SupplierOther: 'SPL.OTHER'
};

export const UploadConstant = {
  Resume: 'RESUME',
  Image: 'IMAGE'
};

export const MediaConstant = {
  Resume: 'resume',
  Image: 'image'
};

export const IsRejectConstant = {
  Reject: 'REJECT.'
};

export const FormsConstant = {
  profileForm: 'profileForm',
  professionalForm: 'professionalForm',
  referenceForm: 'references',
  skillsForm: 'skillsForm',
  otherInfoForm: 'otherForm',
  docForm: 'docsForm'
};

